<template>
    <div>
        <div class="mobileLoginBtnGroup">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <i class="fa fa-user-o" aria-hidden="true" style="font-size: 18px"></i>
              </span>
                <template v-if="userInfo.appstoreIsLogin">
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="appStoreLogOff()">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
                <template v-else>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="routerGoto('/appstore-public/register')">注册</el-dropdown-item>
                        <el-dropdown-item @click.native="routerGoto('/appstore-public/login')">登陆</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
        <div class="d2-mr desktopLoginBtnGroup">
            <template v-if="userInfo.appstoreIsLogin">
                <span class="btn-text" style="font-size: 14px">你好 {{userInfo.name}}</span>
                <el-button plain size="mini" round icon="fa fa-pencil-square-o" @click="appStoreLogOff"> 退出</el-button>
            </template>
            <template v-else>
                <el-button plain size="mini" round icon="fa fa-pencil-square-o" @click="routerGoto('/appstore-public/register')"> 注册</el-button>
                <el-button plain size="mini" round icon="fa fa-user-o" @click="routerGoto('/appstore-public/login')"> 登录</el-button>
            </template>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import { menuHeader, menuAside ,menuAppStore } from '@/menu'
    import util from '@/libs/util.js'
    import {Dialog,Toast } from 'vant'

    export default {
        computed: {
            ...mapState({
                device: state => state.d2admin.device,
                userInfo: state => state.d2admin.userInfo
            })
        },
        methods: {
            ...mapActions([
                'd2adminLogout'
            ]),
            /**
             * @description 登出
             */
            logOff() {
                this.d2adminLogout({
                    vm: this,
                    confirm: true
                })
            },
            routerGoto(name) {
                this.$router.push({
                    path: name
                })
            },
            logoffSuccess() {
                //请求后台的退出接口
                this.$axios.post('/api/userinfo/logout').then(res => {
                    if(res.code == 200 && res.body){
                        // 删除cookie
                        util.cookies.remove('token')
                        util.cookies.remove('uuid')
                        //  设置登陆标识
                        // 设置 vuex 用户信息
                        this.$store.commit('d2adminUserInfoSet', {
                            name: this.userInfo.name,
                            appstoreIsLogin: false
                        })
                        // 设置顶栏菜单
                        this.$store.commit('d2adminMenuHeaderSet', menuHeader)
                        // 设置侧边栏菜单
                        this.$store.commit('d2adminMenuAsideSet', menuAside)
                        // 跳转到登录页面
                        this.$router.push({
                            path: "/appstore-public/login"
                        })
                        this.showMessageInfo('退出成功!')
                    }else{
                        this.alertInfo(res.message)
                    }
                }).catch((error) => {
                    this.showMessageInfo('退出失败！请检查网络！')
                }).then(() => {

                });
            },
            appStoreLogOff() {
                if(this.device==='mobile'){
                    Dialog.confirm({
                        title: '提示',
                        message: '确定要退出吗？'
                    }).then(() => {
                        this.logoffSuccess()
                    }).catch(() => {
                        Toast.success('已取消退出操作')
                    });
                }else{
                    this.$confirm('确定要退出吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.logoffSuccess()
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消退出操作'
                        });
                    });
                }
            },
            showMessageInfo(message){
                if(this.device==='mobile'){
                    Toast.success(message)
                }else{
                    this.$message({
                        type: 'success',
                        message: message
                    })
                }
            },
            alertInfo(message){
                if(this.device==='mobile'){
                    Dialog.alert({
                        title: '提示',
                        message: message
                    }).then(() => {
                    });
                }else{
                    this.$alert(message, '提示')
                }
            }
        }
    }
</script>

<style scoped>
    .mobileLoginBtnGroup{
        display: none;
    }
    @media screen and (max-width: 1030px){
        .desktopLoginBtnGroup{
            display: none;
        }
        .mobileLoginBtnGroup{
            display: block;
        }
    }
</style>
